import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PublicHeader from '../layout/PublicHeader';
import PublicFooter from '../layout/PublicFooter';
import { SERVER_URL } from '../constants/server-type';

import '../App.css';

export default function ResetPasswordPage() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [passwordValidations, setPasswordValidations] = useState({
        minLength: false,
        hasUppercase: false,
        hasLowercase: false,
        hasNumber: false,
        hasSymbol: false,
        isValid: false
    });
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const validatePassword = (password) => {
        const minLength = password.length >= 7;
        const hasUppercase = /[A-Z]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSymbol = /[^A-Za-z0-9]/.test(password);

        return {
            minLength,
            hasUppercase,
            hasLowercase,
            hasNumber,
            hasSymbol,
            isValid: minLength && hasUppercase && hasLowercase && hasNumber && hasSymbol
        };
    };

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        setPasswordValidations(validatePassword(newPassword));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${SERVER_URL}/auth/reset-password/${token}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password })
            });

            if (!response.ok) throw new Error('Reset failed');

            const data = await response.json();
            toast.success(data.message || 'Password reset successfully!');
            setMessage(data.message || 'Password reset successfully! Redirecting to login...');
            setTimeout(() => navigate('/login'), 1500);
        } catch (err) {
            console.error(err);
            toast.error('Password reset failed.');
            setMessage('Password reset failed.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <PublicHeader />
            <div className="form-container">
                <h2>Reset Password</h2>
                {message && <p>{message}</p>}
                <form onSubmit={handleSubmit}>
                    <label>New Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={handlePasswordChange}
                        required
                        disabled={loading}
                    />

                    <div className="password-requirements">
                        <p>Password must contain:</p>
                        <ul>
                            <li style={{ color: passwordValidations.minLength ? 'green' : 'red' }}>
                                Minimum 7 characters
                            </li>
                            <li style={{ color: passwordValidations.hasUppercase ? 'green' : 'red' }}>
                                At least 1 uppercase letter
                            </li>
                            <li style={{ color: passwordValidations.hasLowercase ? 'green' : 'red' }}>
                                At least 1 lowercase letter
                            </li>
                            <li style={{ color: passwordValidations.hasNumber ? 'green' : 'red' }}>
                                At least 1 number
                            </li>
                            <li style={{ color: passwordValidations.hasSymbol ? 'green' : 'red' }}>
                                At least 1 symbol (e.g., !@#$)
                            </li>
                        </ul>
                    </div>

                    <button type="submit" disabled={loading || !passwordValidations.isValid}>
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                </form>
                <div className="link-buttons">
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
            <PublicFooter />
        </div>
    );
}
